import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitPlanModel } from '@apps-common/types/portal/unit'

export const createUnitPlan = async (model: IUnitPlanModel): Promise<IUnitPlanModel> =>
  axios.post(`/management/unitplan/addunitplan`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitPlanModel
}

export const useManagementCreateUnitPlan = (notify?: boolean, onSuccess?: (data: IUnitPlanModel) => void) =>
  useMutation({
    mutationKey: ['createUnitPlan'],
    mutationFn: ({ model }: Props) => createUnitPlan(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created device plan.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create device plan, please try again.')
      }
    },
    throwOnError: false
  })
